'use strict'

const debug = require('debug')('eth-rpc-cache')
const JsonRpcError = require('json-rpc-error')

const clone = require('./utils/clone')
const perBlockStrategy = require('./strategies/per-block')
const permanentStrategy = require('./strategies/permanent')

function createEthRpcCache(rpc, options = {}) {
  debug('Creating EVM RPC cache')

  const { allowOthers = true, cache = new Map(), strategies = [] } = options

  const cachedRpcByMethod = {}
  ;[permanentStrategy, perBlockStrategy]
    .concat(strategies)
    .forEach(function ({ getRpc, methods, name }) {
      debug('Using strategy "%s"', name)
      methods.forEach(function (method) {
        cachedRpcByMethod[method] = getRpc(rpc, cache, options[name])
      })
    })

  // Return the cached `rpc` function.
  //
  // If an strategy defined an RPC function for the incoming method, use that.
  // Otherwise call the method directly if allowed or return proper errors.
  //
  // To prevent user code to mutate the cached results, the cached RPC functions
  // will always return a clone of the result and not the result object itself.
  return function (method, params) {
    const cachedRpc = cachedRpcByMethod[method]

    try {
      return cachedRpc
        ? cachedRpc(method, params).then(clone)
        : allowOthers
        ? rpc(method, params)
        : // @ts-ignore ts(2350)
          Promise.reject(new JsonRpcError.MethodNotFound())
    } catch (err) {
      // @ts-ignore ts(2350)
      return Promise.reject(new JsonRpcError.InternalError(err))
    }
  }
}

module.exports = createEthRpcCache
